export const templateProductTrialsOverlayWindowsApp = document.createElement('template');

templateProductTrialsOverlayWindowsApp.innerHTML = ``;
